import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";


import icon1 from '../Images/product-quality-1.png'
import icon2 from '../Images/product-quality-2.png'
import icon3 from '../Images/product-quality-3.png'
import icon4 from '../Images/product-quality-4.png'

const productFeatures=[
    {
        icon:icon1,
        title:"Best For"
    },
     {
        icon:icon2,
        title:"Suitable Surfaces"
    },
     {
        icon:icon3,
        title:"Application Type"
    },
     {
        icon:icon4,
        title:"Skill Level"
    }
]

const ProductIntro=({photo,subheading,heading,desc,desc2,points,title,product1,product1Big,product2,product2Big,product3,product3Big,photoSmall})=>{
  const fade = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.5 },
  },
};

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.2,
    },
  },
};

const [images, setImages] = useState([
  { small: product1, big: product1Big },
  { small: product2, big: product2Big },
  { small: product3, big: product3Big },
  { small: photoSmall, big: photo }, // 👈 main product from props
]);

const [activeIndex, setActiveIndex] = useState(3); 

const handleSwap = (index) => {
  setActiveIndex(index);
};

useEffect(() => {
  setImages([
    { small: product1, big: product1Big, alt: `${heading} ${title} 1 | VigoFlex`, },
    { small: product2, big: product2Big, alt: `${heading} ${title} 1 | VigoFlex` },
    { small: product3, big: product3Big, alt: `${heading} ${title} 1 | VigoFlex` },
    { small: photoSmall, big: photo, alt: `${title} | VigoFlex`, },
  ]);

  setActiveIndex(3); // reset to main product
}, [
  photo, 
  heading, 
  title, 
  product1, 
  product1Big, 
  product2, 
  product2Big, 
  product3, 
  product3Big, 
  photoSmall
]);

useEffect(() => {
  if (!images.length) return;

  const interval = setInterval(() => {
    setActiveIndex((prev) => (prev + 1) % images.length);
  }, 8000);

  return () => clearInterval(interval);
}, [images]);

    return(
        <>
       <section className="product-intro-section container">
<div className="product-top">

  {/* LEFT SIDE */}
  <div className="product-images-grid">

    {/* SMALL IMAGES */}
 {/* SMALL IMAGES */}
<div className="product-img-wrapper">
  {/* TOP ARROW */}
  <button 
    className="nav-arrow prev" 
    onClick={() => setActiveIndex((prev) => (prev - 1 + images.length) % images.length)}
  >
   <span className="arrow-v up"></span> {/* Or use an SVG/Img */}
  </button>

  <div className="product-img-col">
    {images.map((img, i) => {
      if (i === activeIndex) return null;

      return (
        <motion.div
          key={i}
          whileHover={{ scale: 1.05 }}
          onClick={() => handleSwap(i)}
          style={{ cursor: "pointer" }}
        >
          <img src={img.small} alt={img.alt} />
        </motion.div>
      );
    })}
  </div>

  {/* BOTTOM ARROW */}
  <button 
    className="nav-arrow next" 
    onClick={() => setActiveIndex((prev) => (prev + 1) % images.length)}
  >
   <span className="arrow-v down"></span>
  </button>
</div>

    {/* MAIN IMAGE */}
   <motion.img
  key={activeIndex}
  src={images[activeIndex].big}
alt={images[activeIndex].alt}
  className="main-product-img"
  initial={{ opacity: 0, scale: 0.96 }}
  animate={{ opacity: 1, scale: 1 }}
  transition={{ duration: 0.4 }}
/>

  </div>

  {/* RIGHT SIDE (UNCHANGED) */}
  <motion.div
    className="product-content"
    variants={container}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
  >
    <motion.h3 className="section-subheading" variants={fade}>
      {subheading}
    </motion.h3>

    <motion.h2 className="section-heading" variants={fade}>
      {heading}
    </motion.h2>

    <motion.p className="section-text text-1" variants={fade}>
      {desc}
    </motion.p>

    <motion.p className="section-text" variants={fade}>
      <strong>Ideal For : </strong>{desc2}
    </motion.p>

    <motion.div className="product-btns" variants={fade}>
      <motion.a
        className="btn btn-primary"
        href="/contact-us"
        whileHover={{ scale: 1.03 }}
        whileTap={{ scale: 0.96 }}
      >
        Get a Quote
      </motion.a>

      <motion.a
        href="/calculator"
        className="btn btn-outline"
        whileHover={{ scale: 1.03 }}
        whileTap={{ scale: 0.96 }}
      >
        Calculate Requirement
      </motion.a>

      <motion.a
        href="/files/Vigoflex-msds.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-outline"
        whileHover={{ scale: 1.03 }}
        whileTap={{ scale: 0.96 }}
      >
        Download MSDS
      </motion.a>
    </motion.div>
  </motion.div>

</div>

  {/* BOTTOM */}
  <motion.div
    className="product-bottom"
    variants={container}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
  >
    {productFeatures.map((item, i) => (
      <motion.div
        className="product-feature-card"
        key={i}
        variants={fade}
      >
        <div className="feature-icon-row">
          <div className="product-feature-icon">
            <img src={item.icon} alt={`${item.title} | VigoFlex`} />
          </div>

          <div className="product-feature-col">
            <h4 className="card-heading">{item.title}</h4>
            <p className="section-text">{points[i]}</p>
          </div>
        </div>
      </motion.div>
    ))}
  </motion.div>

</section>
        </>
    )
}
export default ProductIntro;